import { Flex, Image } from "antd";
import { Fade } from "react-awesome-reveal";
import img from "../images/kazhibekov.jpeg";
import MyText from "../../../components/UI/Text/MyText";
import { clrs } from "../../../constants/colors";
import HorizontalDivider from "../../../components/Divider/HorizontalDivider";
import { Link } from "react-router-dom";
import { LinkOutlined } from "@ant-design/icons";
import React from "react";

export const PersonKazhibekov = () => {
    return (
        <Flex style={{ width: "100%", position: "relative" }} vertical gap={20}>
            <Flex style={{ width: "100%", position: "relative" }} gap={40} wrap="wrap">
                <Fade triggerOnce={true} cascade damping={0.15}>
                    <Image src={img} width={240} preview={false} style={{ borderRadius: 16 }} />
                </Fade>
                <Flex style={{ flex: 1, minWidth: 200, position: "relative" }} vertical>
                    <MyText strong size={"large"}>Кажибеков Мади Нуржанович</MyText>
                    <MyText style={{ color: clrs.whiterBlacker }}>
                        Bachelor of Cybersecurity, магистрант по специальности «Информационные системы и технологии»
                    </MyText>
                    <br />
                    <HorizontalDivider />
                    <br />
                    <Flex gap={12} wrap={"wrap"} vertical>
                        <Link target={"_blank"} to={'https://orcid.org/0009-0000-0910-5608'}>
                            <MyText><LinkOutlined /> ORCID</MyText>
                        </Link>
                    </Flex>
                    <br />
                    <MyText strong size={"small"}>Основное место работы, должность</MyText>
                    <MyText>ТОО «Astana IT University», младший научный сотрудник, НИЦ «Industry 4.0». Стаж по профилю — 1 год.</MyText>
                </Flex>
            </Flex>

            <Flex style={{ width: "100%", position: "relative" }} vertical>
                <MyText strong size={"small"}>Роль в проекте</MyText>
                <MyText size={"small"} italic>Младший научный сотрудник / Разработчик</MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - Проектирование и реализация модулей обработки и безопасной передачи данных;
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - Разработка методов кибербезопасности и защиты персональных данных;
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - Создание архитектуры базы данных для хранения и анализа данных;
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - Тестирование и оптимизация программных компонентов.
                </MyText>
            </Flex>

            <Flex style={{ width: "100%", position: "relative" }} vertical>
                <MyText strong size={"small"}>Краткое обоснование участия</MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    Магистрант по теме «Разработка децентрализованной системы на основе блокчейна для проведения государственных тендеров с использованием смарт-контрактов». Python, JavaScript, Rust; клиент-серверная разработка (FastAPI, React), PostgreSQL, ClickHouse, технологии кибербезопасности и шифрования.
                </MyText>
            </Flex>

            <Flex style={{ width: "100%", position: "relative" }} vertical>
                <MyText strong size={"small"}>Научные проекты:</MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - BR24993128 «ИАС трансграничных водных ресурсов» (2024-2026), исполнитель.
                </MyText>
            </Flex>

            <Flex style={{ width: "100%", position: "relative" }} vertical>
                <MyText strong size={"small"}>Публикации:</MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    1. Zhalmagambetova, Neftissov, Biloshchytskyi, Kazambayev, Shimpf, Kazhibekov, Snopkov. A Secure Telemetry Transmission Architecture Independent of GSM: An Experimental LoRa-Based System on Raspberry Pi for IIoT Monitoring Tasks. Applied Sciences, 15(17), 2025. [Scopus Q2]
                </MyText>
            </Flex>
        </Flex>
    );
};
